import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './ExtraMileHeader.css';

const FROM_MOBILE_APP_STORAGE_KEY = 'hf_fromMobileApp';

export default function ExtraMileHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { companyLogoUrl, backButtonUrl } = useSelector((s) => s.ui);
  const user = useSelector((s) => s.auth.user);
  const [logoUrl, setLogoUrl] = useState('');
  const [backUrl, setBackUrl] = useState('');

  useEffect(() => {
    setBackUrl(backButtonUrl || user?.backButtonRedirect || '');
    setLogoUrl(companyLogoUrl || process.env.REACT_APP_EM_LOGO || '');
  }, [backButtonUrl, companyLogoUrl, user]);

  const fromMobileAppInUrl = searchParams.get('fromMobileApp') === 'true';
  useEffect(() => {
    if (!fromMobileAppInUrl) return;
    try {
      sessionStorage.setItem(FROM_MOBILE_APP_STORAGE_KEY, 'true');
    } catch {
      /* ignore */
    }
  }, [fromMobileAppInUrl]);

  const isFromMobileApp = useMemo(() => {
    let fromSession = false;
    try {
      fromSession = sessionStorage.getItem(FROM_MOBILE_APP_STORAGE_KEY) === 'true';
    } catch {
      fromSession = false;
    }
    return fromMobileAppInUrl || fromSession;
  }, [fromMobileAppInUrl]);

  // Hide Back everywhere when opened from the native app (logo uses navigate_back).
  const hideBackButton = isFromMobileApp;

  useEffect(() => {
    if (!backUrl || isFromMobileApp) return undefined;

    const handleBrowserBack = () => {
      window.location.href = backUrl;
    };

    window.history.pushState({ hfBackHandled: true }, '', window.location.href);
    window.addEventListener('popstate', handleBrowserBack);
    return () => window.removeEventListener('popstate', handleBrowserBack);
  }, [backUrl, location.pathname, isFromMobileApp]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.('navigate_back');
  };

  const onBackClick = (e) => {
    if (backUrl) return;
    e.preventDefault();
    if (location.pathname === '/game' || location.pathname === '/thank-you') {
      navigate('/');
      return;
    }
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL || '/'} onClick={handleLogoClick}>
        {logoUrl ? <img src={logoUrl} className="logo-holder" alt="ExtraMile Play" /> : null}
      </a>
      {!hideBackButton ? (
        <div className="back-holder">
          <a href={backUrl || '#'} className="back-default" onClick={onBackClick}>
            Back
          </a>
        </div>
      ) : null}
    </header>
  );
}
